module.exports = __webpack_public_path__ + "0bbcecc387d362779f3e2856086dd55d.svg";